<template>
  <div>
    <!-- <div class="spinner-grow" v-if="loading === true"></div> -->

    <div class="cont">
      <div class="row" style="row-gap: 10px">
        <div
          v-for="stats in statsCards"
          :key="stats.title"
          class="col-md-6 col-xl-3"
        >
          <Stats
            :icon-class="stats.icon"
            :icon-type="stats.type"
            :title="stats.title"
            :value="stats.value"
            :footer-icon="stats.footerIcon"
            :footer-text="stats.footerText"
          />
        </div>
      </div>

      <div class="fre">
        <div>
          <Select
            id="status"
            label="Status"
            v-model="status"
            :options="transactionStatus"
            placeholder="Select a Transaction Status"
          />
        </div>

        <div>
          <Select
            id="limit"
            label="Limit"
            v-model="limit"
            :options="pageLimit"
            placeholder="Select a Page Limit"
          />
        </div>

        <div>
          <Select
            id="params"
            label="Filter By:"
            v-model="selectedValue"
            :options="transactionParams"
            placeholder="Select a Search Parameter"
          />
        </div>

        <div v-if="selectedValue">
          <label for="">Enter Value</label>
          <input
            type="text"
            id="inlineFormInputGroup"
            class="form-control"
            v-model="searchValues[selectedValue]"
            :placeholder="formatPlaceholder(selectedValue)"
          />
        </div>

        <div>
          <label :for="`input-start`">Start Date</label>
          <input
            id="input-start"
            type="date"
            class="form-control"
            v-model="startDate"
          />
        </div>

        <div>
          <label :for="`input-end`">End Date</label>
          <input
            id="input-end"
            type="date"
            class="form-control"
            v-model="endDate"
          />
        </div>

        <div class="d-flex align-items-end w-100" style="gap: 10px">
          <button
            type="submit"
            class="tab-btn btn-info _btn w-100 d-flex justify-content-center align-items-center"
            @click="refreshData('filter')"
          >
            <span v-if="loading" class="spin"></span> Filter
          </button>

          <button
            type="submit"
            class="tab-btn btn-info _btn w-100 d-flex justify-content-center align-items-center"
            @click="downloadList"
            :style="{ display: isInstitution ? 'none' : 'table-cell' }"
          >
            Download
          </button>

          <button
            class="tab-btn btn-info _btn w-100 d-flex justify-content-center align-items-center"
            @click="refreshData('refresh')"
          >
            Refresh
          </button>

          <button
            class="tab-btn btn-info"
            @click="sendBatchRequery()"
            style="display: none"
          >
            Send Batch Requery
          </button>
        </div>

        <!-- <div class="d-flex align-items-end" style="gap: 10px">
          <button
            type="submit"
            class="tab-btn btn-info"
            @click="downloadList"
            :style="{ display: isInstitution ? 'none' : 'table-cell' }"
          >
            Download
          </button>

          <button class="tab-btn btn-info" @click="refreshData('refresh')">
            Refresh
          </button>

          <button
            class="tab-btn btn-info"
            @click="sendBatchRequery()"
            style="display: none"
          >
            Send Batch Requery
          </button>
        </div> -->
      </div>

      <!-- <div class="table-responsive">
        <table class="table">
          <thead class="thead-dark">
            <tr>
              <th scope="col">S/N</th>
              <th scope="col">Transaction Type</th>
              <th scope="col">Terminal ID</th>
              <th scope="col">Wallet ID</th>
              <th scope="col">Card Number</th>
              <th scope="col">Stan</th>
              <th scope="col">Merchant Id</th>
              <th scope="col">Amount</th>
              <th scope="col">Reference</th>
              <th scope="col">Processor</th>
              <th scope="col">Response Code</th>
              <th scope="col">Message</th>
              <th scope="col">Date</th>
              <th scope="col">Action</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(purchase, index) in purchases" :key="purchase._id">
              <td>{{ index + 1 + (currentPage - 1) * limit }}</td>
              <td class="purchase-type">
                {{ purchase.product.toUpperCase() }}
              </td>
              <td>{{ purchase.terminalId }}</td>
              <td>{{ purchase.walletId }}</td>
              <td>{{ purchase.maskedPan }}</td>
              <td>{{ purchase.stan }}</td>
              <td>
                {{
                  purchase.terminalInformation
                    ? purchase.terminalInformation.merchantId
                    : "--"
                }}
              </td>
              <td>{{ `₦${formatCurrency(purchase.amount)}` }}</td>
              <td class="ref">{{ purchase.reference || "Null" }}</td>
              <td>{{ purchase.provider || "N/A" }}</td>
              <td>
                <button :class="getResponseCodeClass(purchase)">
                  {{ purchase.response ? purchase.response.responseCode : "" }}
                </button>
              </td>
              <td>
                {{ purchase.response ? purchase.response.description : "--" }}
              </td>
              <td>{{ formatDate(purchase.createdAt) }}</td>
              <td class="details" @click="updateModal(true, purchase)">
                View Details
              </td>
            </tr>
          </tbody>
        </table>
      </div> -->

      <DynamicTable
        :columns="columns"
        :data="tableData"
        :tableLoading="loading"
      >
        <template #responseCode="{ row }">
          <button :class="getResponseCodeClass(row.raw)">
            {{ row.responseCode }}
          </button>
        </template>

        <template #actions="{ row }">
          <span class="details" @click="updateModal(true, row.raw)"
            >View Details</span
          >
        </template>
      </DynamicTable>

      <!-- <div>
        <table>
          <tr>
            <th>Name</th>
            <th>Ingredients</th>
            <th>Appetizer</th>
            <th>Allergy</th>
            <th>Restaurant</th>
            <th>Amount</th>
          </tr>

          <tr>
            <td data-cell="Name">Apple Pie</td>
            <td data-cell="Ingrdients">apple, sugar, flour, eggs</td>
            <td data-cell="Appetizer">sugar</td>
            <td data-cell="Allergy">apple</td>
            <td data-cell="Restaurant">McDonalds</td>
            <td data-cell="Amount">$10</td>
          </tr>

          <tr>
            <td data-cell="Name">Chicken Burger</td>
            <td data-cell="Ingredients">chicken, bread, cheese</td>
            <td data-cell="Appetizer">cheese</td>
            <td data-cell="Allergy">chicken</td>
            <td data-cell="Restaurant">McDonalds</td>
            <td data-cell="Amount">$10</td>
          </tr>

          <tr>
            <td data-cell="Name">Chicken Sandwich</td>
            <td data-cell="Ingredients">chicken, bread, cheese</td>
            <td data-cell="Appetizer">cheese</td>
            <td data-cell="Allergy">chicken</td>
            <td data-cell="Restaurant">McDonalds</td>
            <td data-cell="Amount">$10</td>
          </tr>
        </table>
      </div> -->

      <div class="pagination">
        <div class="to-flex">
          <button
            class="btn pagination-btn"
            :disabled="!hasPrevPage"
            @click="refreshData('prev')"
          >
            Previous
          </button>

          <span>Page {{ currentPage }} of {{ totalPages }}</span>

          <button
            class="btn pagination-btn"
            :disabled="!hasNextPage"
            @click="refreshData('next')"
          >
            Next
          </button>
        </div>

        <div class="p-2">
          <div class="btn pagination-btn">Total Records: {{ totalDocs }}</div>
        </div>
      </div>
    </div>

    <TransactionDetailsModal
      :show-trans-detail="showTransDetail"
      :close-modal="closeModal"
      :modal-trans-detail="modalTransDetail"
    />
  </div>
</template>

<script>
import axios from "../store/axios";
import moment from "moment";
import fileDownload from "js-file-download";
import { convertArrayToCSV } from "convert-array-to-csv";
import { mapActions, mapState } from "vuex";
import { Select, Stats } from "@/components/index.js";
import { capitalize } from "../utils/utils";
import {
  pageLimit,
  statsCards,
  transactionStatus,
  transactionParams,
} from "../constants/index";
import TransactionDetailsModal from "./Modals/TransactionDetailsModal.vue";
import DynamicTable from "../components/DynamicTable.vue";

export default {
  components: {
    Select,
    Stats,
    TransactionDetailsModal,
    DynamicTable,
  },
  data() {
    return {
      showTransDetail: false,
      loading: false,
      error: false,
      download: false,
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      errorMsg: "",
      status: "",
      selectedValue: "",
      format: new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      currentPage: 1,
      limit: 20,
      transactionsLimit: "",
      totalPages: 0,
      hasNextPage: false,
      hasPrevPage: false,
      totalDocs: 0,
      payload: {},
      purchases: [],
      filteredPurchases: [],
      dateRange: [],
      searchValues: {
        terminalId: "",
        walletId: "",
        reference: "",
        stan: "",
      },
      moment,
      modalTransDetail: {},
      transaction: {
        response: {
          responseCode: "00",
        },
      },
      pageLimit,
      statsCards,
      transactionParams,
      transactionStatus,
      product: "purchase",
      userType: localStorage.getItem("userType"),

      columns: [
        { label: "S/N", key: "sn" },
        { label: "Transaction Type", key: "product" },
        { label: "Terminal ID", key: "terminalId" },
        { label: "Wallet ID", key: "walletId" },
        { label: "Card Number", key: "maskedPan" },
        { label: "Stan", key: "stan" },
        { label: "Merchant Id", key: "merchantId" },
        { label: "Amount", key: "amount" },
        { label: "Reference", key: "reference" },
        { label: "Processor", key: "provider" },
        { label: "Response Code", key: "responseCode" },
        { label: "Message", key: "message" },
        { label: "Date", key: "createdAt" },
        { label: "Action", key: "actions" },
      ],
    };
  },
  computed: {
    ...mapState(["auth"]),
    isInstitution() {
      return this.userType === "INSTITUTIONS";
      //   return this.userType === 'super-admin';
    },

    tableData() {
      return this.purchases.map((purchase, index) => ({
        sn: index + 1 + (this.currentPage - 1) * this.limit,
        product: purchase.product.toUpperCase() || "",
        terminalId: purchase.terminalId,
        walletId: purchase.walletId,
        maskedPan: purchase.maskedPan,
        stan: purchase.stan,
        merchantId: purchase.terminalInformation.merchantId || "--",
        amount: `₦${this.formatCurrency(purchase.amount)}`,
        reference: purchase.reference || "Null",
        provider: purchase.provider || "N/A",

        responseCode:
          (purchase.response && purchase.response.responseCode) || "N/A",
        message: (purchase.response && purchase.response.description) || "--",
        createdAt: this.formatDate(purchase.createdAt),
        raw: purchase,
      }));
    },
  },
  methods: {
    ...mapActions(["setNotification"]),
    capitalize,
    formatDate(date) {
      return moment.utc(date).format("DD-MM-YYYY, hh:mm a"); // removed utc to display in local time
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value / 100);
    },
    updateModal(showTD, tran) {
      this.showTransDetail = showTD;
      this.modalTransDetail = tran;
    },
    closeModal() {
      this.showTransDetail = false;
    },
    getResponseCodeClass(transaction) {
      return {
        "text-center": true,
        "code-btn": true,
        successful:
          transaction.response && transaction.response.responseCode === "00",
        other:
          transaction.response && transaction.response.responseCode !== "00",
      };
    },
    resetFiltersAndPagination() {
      this.status = "";
      this.selectedValue = "";
      this.clearSearchFields();
      this.currentPage = 1;
      this.startDate = moment().format("YYYY-MM-DD");
      this.endDate = moment().format("YYYY-MM-DD");
    },
    buildPayload(mode) {
      const basePayload = {
        page: this.currentPage,
        limit: this.limit,
        startDate: this.startDate,
        endDate: this.endDate,
        product: this.product,
        download: mode === "download",
      };

      if (mode !== "refresh") {
        return {
          ...basePayload,
          status: this.status,
          ...this.searchValues,
          ...(mode === "download" && { download: true }),
          ...(mode === "next" && { page: ++this.currentPage }),
          ...(mode === "prev" && { page: --this.currentPage }),
        };
      }

      return basePayload;
    },
    updateStatsCards({ failed, successful, total, pending }) {
      [total, successful, pending, failed].forEach((value, index) => {
        this.statsCards[index].value = `₦${this.formatCurrency(value)}`;
      });
    },
    handleApiResponse(response, mode) {
      if (mode === "download") {
        fileDownload(
          convertArrayToCSV(response.data.transactions),
          "transactions.csv",
        );
      } else {
        const {
          docs,
          hasNextPage,
          hasPrevPage,
          totalPages,
          prevPage,
          nextPage,
          totalDocs,
          page,
        } = response.data.transactions;

        Object.assign(this, {
          purchases: docs,
          hasNextPage,
          hasPrevPage,
          totalPages,
          prevPage,
          nextPage,
          totalDocs,
          currentPage: page,
        });
        this.updateStatsCards(response.data.summary);
      }
    },
    async refreshData(mode) {
      try {
        this.loading = true;

        if (mode === "refresh") this.resetFiltersAndPagination();

        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}/transactions/purchase`,
          this.buildPayload(mode),
        );

        this.handleApiResponse(response, mode);
      } catch (error) {
        const errorMessage =
          error.response.data.message || "Unable to Fetch Transactions";
        this.setNotification({ type: "danger", message: errorMessage });
      } finally {
        this.loading = false;
      }
    },
    async sendBatchRequery() {
      this.$confirm("Send Batch Requery?").then(async () => {
        this.loading = true;
        try {
          const res = await axios.post(
            `${process.env.VUE_APP_API_URL}/transaction/tms/kimono-batch-requery`,
            { ids: this.unsentList },
          );
          const { message } = res.data;
          this.setNotification({
            type: "success",
            message,
          });
          this.refresh("");
        } catch (error) {
          if (error.response && error.response.data) {
            const { message } = error.response.data;
            this.setNotification({ type: "danger", message });
          } else {
            this.setNotification({
              type: "danger",
              message: "Unable to Send Requery",
            });
          }
        }
        this.loading = false;
      });
    },
    downloadList() {
      // fileDownload(convertArrayToCSV(this.purchases), "transactions.csv");
      this.refreshData("download");
    },
    formatPlaceholder(value) {
      if (value === "terminalId") return "Enter Terminal ID";
      if (value === "walletId") return "Enter Wallet ID";
      if (value === "reference") return "Enter Reference";
      if (value === "stan") return "Enter Stan";
      return "Enter Value";
    },
    clearSearchFields() {
      Object.keys(this.searchValues).forEach((key) => {
        this.searchValues[key] = "";
      });
    },
  },
  watch: {
    selectedValue() {
      this.clearSearchFields();
    },
  },
  async mounted() {
    this.refreshData();
  },
};
</script>

<style scoped>
h1 {
  margin: 0;
}

label {
  color: #9a9a9a;
  font-size: 10px;
}

input {
  background-color: #fafafa;
  font-size: 10px;
}

.table-responsive {
  overflow: scroll;
}

/* tr > td {
  border-top: 0.5px solid #e8e9eb !important;
}

th,
td {
  letter-spacing: 0px;
  font-size: 12px !important;
  font-weight: 400;
  font-family: Arial, sans-serif;
  text-align: center;
  white-space: nowrap;
}

td {
  padding: 20px !important;
} */

table {
  background: #ffffff;
  width: 100%;
}

th,
td {
  padding: 1rem;
}

th {
  background: #333f48;
  color: white;
}

tr:nth-of-type(2n) {
  background: #f1f1f1;
}

@media (max-width: 768px) {
  th {
    display: none;
  }
  td {
    display: grid;
    grid-template-columns: 15ch auto;
    padding: 0.5rem 1rem;
  }
  td:first-child {
    padding-top: 2rem;
  }
  td:last-child {
    padding-bottom: 2rem;
  }
  td::before {
    content: attr(data-cell) ": ";
    font-weight: bold;
    text-transform: capitalize;
    color: #008000;
  }
}
.col-md-3 {
  padding: 0;
}

.col-md-6,
.col-xl-3 {
  padding: 0 5px;
}

.fre {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  margin: 15px 0;
}

.spinner-grow {
  position: fixed;
}

.purchase-type {
  text-transform: uppercase;
}

.details {
  letter-spacing: 0.1px;
  font-size: 10px !important;
  word-spacing: 0.1px;
  font-weight: 600;
  background-color: transparent;
  cursor: pointer;
  color: #0047ab;
}

.to-flex {
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: space-between;
}

.pagination {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}

.pagination-btn {
  font-size: 10px !important;
  letter-spacing: 0.8px;
}

.tms-dark {
  background-color: #333f48;
  color: #fff;
}

.ref {
  font-size: 8px;
}

.code-btn {
  padding: 8px 15px !important;
  border: none;
  border-radius: 4px;
}

.successful {
  background-color: #d6ffd9;
  color: #008000;
  font-weight: bolder;
}

.other {
  background-color: #ffd5d6;
  color: #f40009;
  font-weight: bolder;
}

._btn {
  gap: 8px;
  height: 40px;
}

.spin {
  border: 2px solid rgba(101, 179, 199, 0.2);
  border-left-color: #65b3c7;
  width: 15px;
  height: 15px;
}

@media (max-width: 768px) {
  .fre {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}
</style>
